import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { MyPlannCzechResourcesDictionary } from "web_myplann/Infrastructure/Translations/CzechResourcesDictionary";
import { MyPlannEnglishResourcesDictionary } from "web_myplann/Infrastructure/Translations/EnglishResourcesDictionaty";

export const initI18n = () => {
	i18n.use(initReactI18next).init({
		resources: {
			cs: { translation: MyPlannCzechResourcesDictionary },
			en: { translation: MyPlannEnglishResourcesDictionary },
		},
		lng: "cs",
		fallbackLng: "cs",
		interpolation: { escapeValue: false },
	});
};
